var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      staticClass: "fill-height"
    },
    [
      _c(
        "v-skeleton-loader",
        {
          attrs: {
            loading: _vm.loading,
            type: "article"
          }
        },
        [
          _c(
            "gg-card-header",
            [
              _vm._v(" Payment Method "),
              _c(
                "gg-btn",
                {
                  staticClass: "float-right",
                  attrs: {
                    primary: ""
                  },
                  on: {
                    click: _vm.triggerModal
                  }
                },
                [_vm._v(" Edit ")]
              )
            ],
            1
          ),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("div", [
                        _c("p", [
                          _vm._v(" Current Payment Method: "),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.paymentMethod) +
                                " " +
                                _vm._s(_vm.paymentEmail)
                            )
                          ])
                        ])
                      ]),
                      _c("div", [
                        _c(
                          "p",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "affiliates_payments"
                                  }
                                }
                              },
                              [_vm._v(" View Payment History ")]
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.modal
        ? _c("gg-modal", {
            attrs: {
              "is-active": _vm.modal
            },
            on: {
              close: _vm.triggerModal
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "toolbar",
                  fn: function fn() {
                    return [_vm._v("Change PayPal Address")]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function fn() {
                    return [
                      _c("gg-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'"
                          }
                        ],
                        attrs: {
                          label:
                            "Enter your PayPal address. This change will take place immediately. ",
                          name: "Email",
                          "error-messages": _vm.errors.collect("Email")
                        },
                        model: {
                          value: _vm.email,
                          callback: function callback($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      })
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function fn() {
                    return [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: ""
                          },
                          on: {
                            click: _vm.triggerModal
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            primary: "",
                            loading: _vm.pending
                          },
                          on: {
                            click: _vm.changeEmail
                          }
                        },
                        [_vm._v("Save")]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2094159238
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }